import { Link } from "react-router-dom";
import Photo from "../ui/Photo";
import { staffFor } from "../../data/salon";
import { duration, toman } from "../../lib/format";
import { useBooking } from "../../lib/booking";
import "./layout.css";

export default function BookingDrawer() {
  const b = useBooking();

  return (
    <div className={`bdrawer${b.open ? " is-open" : ""}`} aria-hidden={!b.open}>
      <button
        type="button"
        className="bdrawer__scrim"
        aria-label="بستن سبد نوبت"
        tabIndex={b.open ? 0 : -1}
        onClick={() => b.setOpen(false)}
      />

      <aside
        className="bdrawer__panel"
        role="dialog"
        aria-modal="true"
        aria-label="سبد نوبت"
      >
        <header className="bdrawer__head">
          <div>
            <span className="eyebrow">YOUR APPOINTMENT</span>
            <h2>سبد نوبت</h2>
          </div>
          <button type="button" onClick={() => b.setOpen(false)} aria-label="بستن">✕</button>
        </header>

        {b.count === 0 ? (
          <div className="bdrawer__empty">
            <p>هنوز خدمتی انتخاب نکرده‌ای.</p>
            <Link to="/services" className="btn btn--sm" onClick={() => b.setOpen(false)}>
              دیدن خدمات
            </Link>
          </div>
        ) : (
          <>
            <ul className="bdrawer__list">
              {b.items.map((i) => {
                const options = staffFor(i.category);
                return (
                  <li key={i.key} className="bitem">
                    <Photo src={i.photo} alt="" ratio="1 / 1" className="bitem__art" />

                    <div className="bitem__body">
                      <h3>{i.name}</h3>
                      <p className="bitem__meta">{duration(i.duration)}</p>

                      {options.length > 0 && (
                        <label className="bitem__staff">
                          <span className="sr-only">انتخاب متخصص برای {i.name}</span>
                          <select
                            value={i.staffId ?? ""}
                            onChange={(e) =>
                              b.setStaff(i.key, e.target.value ? Number(e.target.value) : null)
                            }
                          >
                            <option value="">بدون ترجیح متخصص</option>
                            {options.map((s) => (
                              <option key={s.id} value={s.id}>{s.name}</option>
                            ))}
                          </select>
                        </label>
                      )}
                    </div>

                    <div className="bitem__side">
                      <span className="bitem__price">{toman(i.price)}</span>
                      <button
                        type="button"
                        onClick={() => b.remove(i.key)}
                        aria-label={`حذف ${i.name}`}
                      >
                        حذف
                      </button>
                    </div>
                  </li>
                );
              })}
            </ul>

            <footer className="bdrawer__foot">
              <div className="bdrawer__row">
                <span>مدت تقریبی</span>
                <strong>{duration(b.minutes)}</strong>
              </div>
              <div className="bdrawer__row bdrawer__row--total">
                <span>جمع</span>
                <strong>{toman(b.total)}</strong>
              </div>

              <Link to="/booking" className="btn btn--block" onClick={() => b.setOpen(false)}>
                ادامه و انتخاب زمان
              </Link>

              <button type="button" className="bdrawer__clear" onClick={b.clear}>
                خالی کردن سبد
              </button>
            </footer>
          </>
        )}
      </aside>
    </div>
  );
}
